import { Injectable } from '@angular/core';
import { RouteConfig } from '../route.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class HttpClientService {
  constructor(
    private http: HttpClient,
    private routeConfig: RouteConfig,
  ) { }

  //######################## Http method to make anonymous request : start ########################
  get<T>(url: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.apiKey
    });
    const options = { headers: headers };
    return this.http.get<T>(this.routeConfig.Url(url), options);
  }

  post<TData, TResult>(url: string, data: TData) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.apiKey
    });
    const httpOptions = { headers: headers };
    let body = JSON.stringify(data);

    return this.http.post<TResult>(
      this.routeConfig.Url(url),
      body,
      httpOptions,
    );
  }

  put<TData, TResult>(url: string, data: TData) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.apiKey
    });
    const httpOptions = { headers: headers };
    let body = JSON.stringify(data);

    return this.http.put<TResult>(
      this.routeConfig.Url(url),
      body,
      httpOptions,
    );
  }

  delete<T>(url: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.apiKey
    });
    const options = { headers: headers };
    return this.http.delete<T>(this.routeConfig.Url(url), options);
  }

  fileUpload<T>(url: string, files: { [key: string]: any }, bodyParams: string = "") {
    let input = new FormData();

    // Append files to FormData
    for (let key in files) {
      if (files.hasOwnProperty(key)) {
        input.append(key, files[key]);
      }
    }

    if (bodyParams != "") {
      input.append("requestFormData", bodyParams);
    }

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('x-api-key', environment.apiKey);
    return this.http.post<T>(this.routeConfig.Url(url), input, { headers: headers });
  }

  fileUploadWithParam<T>(url: string, file: any, luckyDrawId: string = "") {
    let input = new FormData();
    input.append("file", file);
    input.append("luckyDrawId", luckyDrawId);


    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('x-api-key', environment.apiKey);
    return this.http.post<T>(this.routeConfig.Url(url), input, { headers: headers });
  }

  fileUploadPut<T>(url: string, files: { [key: string]: any }, bodyParams: string = "") {
    let input = new FormData();

    // Append files to FormData
    for (let key in files) {
      if (files.hasOwnProperty(key)) {
        input.append(key, files[key]);
      }
    }

    if (bodyParams != "") {
      input.append("requestFormData", bodyParams);
    }

    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('x-api-key', environment.apiKey);
    return this.http.put<T>(this.routeConfig.Url(url), input, { headers: headers });
  }
  //######################## Http method to make anonymous request : End ##########################

  //######################## Http method to make authorize request : start ########################

  authGet<T>(url: string) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set(
      'Authorization',
      'Bearer ' + localStorage.getItem('access_token'),
    );
    const options = { headers: headers };
    return this.http.get<T>(this.routeConfig.Url(url), options);
  }

  authPost<T>(url: string, data: T) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set(
      'Authorization',
      'Bearer ' + localStorage.getItem('access_token'),
    );

    const options = { headers: headers };
    let body = JSON.stringify(data);

    return this.http.post<T>(this.routeConfig.Url(url), body, options);
  }

  authPut<T>(url: string, data: T) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set(
      'Authorization',
      'Bearer ' + localStorage.getItem('access_token'),
    );

    const options = { headers: headers };
    let body = JSON.stringify(data);

    return this.http.put<T>(this.routeConfig.Url(url), body, options);
  }

  authDelete<T>(url: string) {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    headers = headers.set(
      'Authorization',
      'Bearer ' + localStorage.getItem('access_token'),
    );

    const options = { headers: headers };
    return this.http.delete<T>(this.routeConfig.Url(url), options);
  }

  authFileUpload(url: string, file: any) {
    let input = new FormData();
    input.append("file", file);
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    const httpOptions = { headers: headers }
    return this.http.post<any>(this.routeConfig.Url(url), input, httpOptions)
  }

  authMultipleFileUpload(url: string, files: any[], model?: any) {
    let input = new FormData();

    if (files && files.length > 0) {
      for (let file of files) {
        input.append(file.name, file);
      }
    }

    input.append("model", JSON.stringify(model));
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    headers = headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token'));
    const httpOptions = { headers: headers }
    return this.http.post<any>(this.routeConfig.Url(url), input, httpOptions)
  }
  //######################## Http method to make authorize request : End ##########################
}
